// EG header behaviour. Core assets/header.js never loads for the custom
// header (only core header.liquid loaded it), so this module owns:
//   1. sticky="scroll-up" hide/reveal (toggles [data-eg-hidden]);
//   2. keeping --header-height / --header-group-height up to date on resize.
// Variables are set on document.body to match theme.liquid's inline initial
// script — a value set on <html> would be shadowed by the body-level one.
const init = () => {
  const header = document.querySelector('.header-section > header-component');
  if (!header || header.dataset.egHeaderInit) return;
  header.dataset.egHeaderInit = 'true';

  const headerGroup = document.querySelector('#header-group');

  const updateHeights = () => {
    document.body.style.setProperty('--header-height', `${Math.round(header.offsetHeight)}px`);
    if (!headerGroup) return;
    let groupHeight = 0;
    for (const child of headerGroup.children) {
      if (child === header || !(child instanceof HTMLElement)) continue;
      groupHeight += child.offsetHeight;
    }
    document.body.style.setProperty('--header-group-height', `${Math.round(groupHeight)}px`);
  };

  const resizeObserver = new ResizeObserver(updateHeights);
  resizeObserver.observe(header);
  if (headerGroup) {
    for (const child of headerGroup.children) {
      if (child instanceof HTMLElement) resizeObserver.observe(child);
    }
  }

  // sticky="scroll-up": hide when scrolling down past the header, reveal on
  // any upward scroll. No-op for "always" and "never".
  let lastScrollY = window.scrollY;
  const onScroll = () => {
    if (header.getAttribute('sticky') !== 'scroll-up') return;
    const y = window.scrollY;
    if (y > lastScrollY && y > header.offsetHeight) {
      header.setAttribute('data-eg-hidden', '');
    } else if (y < lastScrollY) {
      header.removeAttribute('data-eg-hidden');
    }
    lastScrollY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Theme editor replaces the section's DOM; re-run for the fresh element.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', init);
}
